import DateUtil from '../../../lib/dateutil.jsx'

/**
 * in reports you can select Today, Yesterday ,... as date filters.
 * this data will be saved for user with the value of today, yesterday, ...
 * next days, when user comes back to reports Today dateFilter contains outdated today value.
 * to solve the issue, saved dataFilter is updated according to currentDate
 * @param {*} dateFilter
 */
const getCurrentDateFilters = dateFilter => {
  const date = DateUtil.getUTCCurrentDate()
  const currYear = DateUtil.getLocalYear()
  const currMonth = DateUtil.getLocalMonth()
  const currDay = date.getDate()

  const lastWeekStartDate = DateUtil.getMondayByDate(new Date())
  lastWeekStartDate.setDate(lastWeekStartDate.getDate() - 7)

  const lastWeekEndDate = new Date(lastWeekStartDate)
  lastWeekEndDate.setDate(lastWeekStartDate.getDate() + 6)

  const currentDateFilterValues = {
    today: DateUtil.getUTCDate(currYear, currMonth, currDay),
    yesterday: DateUtil.getUTCDate(currYear, currMonth, currDay - 1),
    'end-of-lastmonth': DateUtil.getUTCDate(currYear, currMonth, 0),
    'this-year': {
      from: DateUtil.getUTCDate(currYear, 0, 1),
      to: DateUtil.getUTCDate(currYear, 11, 31)
    },
    'last-week': {
      from: DateUtil.getUTCDateFromDate(lastWeekStartDate),
      to: DateUtil.getUTCDateFromTime(lastWeekEndDate)
    },
    'last-month': {
      from: DateUtil.getUTCDate(currYear, currMonth - 1, 1),
      to: DateUtil.getUTCDate(currYear, currMonth, 0)
    },
    'last-year': {
      from: DateUtil.getUTCDate(currYear - 1, 0, 1),
      to: DateUtil.getUTCDate(currYear - 1, 11, 31)
    },
    'this-month': {
      from: DateUtil.getUTCDate(currYear, currMonth, 1),
      to: DateUtil.getUTCDate(currYear, currMonth + 1, 0)
    }
  }

  // it is a bad practice to mute input. this change is to trigger state update for date input
  dateFilter.value =
    currentDateFilterValues[dateFilter.ident] || dateFilter.value

  return dateFilter
}

export default getCurrentDateFilters
